<div class="sectpad container p-0 mt-2">
  <div class="col-sm-9 m-auto p-0 mbwidth">
    <div class="col-12 p-0">
      <h5 class="bloghead semi-bold mb-1">Honest Gorilla Blog</h5>
      <!-- <hr class="hrbdr" /> -->
      <p class="font-weight-normal-calibre blogsubhead">We deliver the freshest news content and insights about
        homes, living and energy. These stories help to bring
        prespective to topics that directly affect life, honestly.</p>
    </div>
    <div *ngFor="let blog of blogsList; let i = index">
      <div class="row" *ngIf="i % 2 == 0">
        <div class="col-12 d-flex p-0 pb-1 pt-1">
          <div class="col-6 text-center pl-0 pr-1" *ngIf="i < blogsList.length">
            <div class="card h-100">
              <p class="h-100 blogs font-weight-normal-calibre p-3 mb-0" (click)="readMore(blogsList[i].article_header)" >{{blogsList[i].article_header}}</p>
              <hr class="blogbdr" />
              <a class="blogbtn semi-bold mb-3" (click)="readMore(blogsList[i].article_header)">Read
                More</a>
            </div>
          </div>
          <div class="col-6 text-center pl-0 pr-1" *ngIf="i+1 < blogsList.length">
            <div class="card h-100">
              <p class="h-100 blogs font-weight-normal-calibre p-3 mb-0" (click)="readMore(blogsList[i+1].article_header)">{{blogsList[i+1].article_header}}</p>
              <hr class="blogbdr" />
              <a class="blogbtn semi-bold mb-3" (click)="readMore(blogsList[i+1].article_header)">Read
                More</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="col-12 d-flex p-0 pb-1 pt-1">
      <div class="col-6 text-center pl-0 pr-1">
        <div class="card h-100">
          <p class="h-100 blogs font-weight-normal-calibre p-3 mb-0">If you’re not saving energy, you’re burning money</p>
          <hr class="blogbdr" />
          <a class="blogbtn semi-bold mb-3" href="#blogmodal" data-toggle="modal" data-target="#blogmodal" (click)="readMore()">Read
            More</a>
        </div>
      </div>
      <div class="col-6 text-center pr-0 pl-1">
        <div class="card h-100">
          <p class="h-100 blogs font-weight-normal-calibre p-3 mb-0">Why you shouldn’t trust anyone’s recommendation when it comes to this one thing.</p>
          <hr class="blogbdr" />
          <a class="blogbtn semi-bold mb-3" href="javascript:void(0)" data-toggle="modal" data-target="#blogmodal"
            (click)="readMore()">Read
            More</a>
        </div>
      </div>
    </div>
    <div class="col-12 d-flex p-0 pb-1 pt-1">
      <div class="col-6 text-center pl-0 pr-1">
        <div class="card h-100">
          <p class="h-100 blogs font-weight-normal-calibre p-3 mb-0">Your home as a fortress for well-being</p>
          <hr class="blogbdr" />
          <a class="blogbtn semi-bold mb-3" href="javascript:void(0)" data-toggle="modal" data-target="#blogmodal"
            (click)="readMore()">Read
            More</a>
        </div>
      </div>
      <div class="col-6 text-center pr-0 pl-1">
        <div class="card h-100">
          <p class="h-100 blogs font-weight-normal-calibre p-3 mb-0">3 things you need to know before renting an apartment</p>
          <hr class="blogbdr" />
          <a class="blogbtn semi-bold mb-3" href="javascript:void(0)" data-toggle="modal" data-target="#blogmodal"
            (click)="readMore()">Read
            More</a>
        </div>
      </div>
    </div> -->
  </div>
</div>

<div class="modal fade" id="blogmodal" data-easein="expandIn" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
  aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <button type="button" class="close videoclose" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="mt-4 text-center">
          <h6 class="font19">Modal Header</h6>
        </div>
        <div class="mt-3 font-weight-normal-calibre">
          <p>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
            tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
            quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
            consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
            cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
            proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
          </p>
        </div>
        <div class="text-right">
          <button class="btn btn-wpink-primary mr-2" data-dismiss="modal" aria-hidden="true">
            Close
          </button>
          <button class="btn sectbtn" data-dismiss="modal" aria-hidden="true">
            Read More
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <div id="blogmodal" class="modal" data-easein="expandIn" tabindex="-1" role="dialog" aria-labelledby="costumModalLabel"
  aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close videoclose" data-dismiss="modal" aria-hidden="true">
          ×
        </button>
        <h4 class="modal-title">
          Modal Header
        </h4>
      </div>
      <div class="modal-body">
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
          tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
          quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
          consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
          cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
          proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
        </p>
      </div>
      <div class="modal-footer">
        <button class="btn btn-default" data-dismiss="modal" aria-hidden="true">
          Close
        </button>
        <button class="btn btn-primary">
          Save changes
        </button>
      </div>
    </div>
  </div>
</div> -->